import { Box, Paper, Typography } from "@mui/material";
import { ChatLine, ChatRole } from "src/api/ai";
import { AssistantSegments } from "./AssistantSegments";
import { styles } from "./ChatSlideout";
import { FormattedText } from "./FormattedText";

type ChatMessageProps = {
  line: ChatLine;
  onApply?: (caption: string) => void;
  onClose: () => void;
};

export function ChatMessage({ line, onApply, onClose }: ChatMessageProps) {
  if (line.role === ChatRole.Assistant) {
    return (
      <Box sx={styles.assistantRow}>
        <Paper elevation={0} sx={styles.assistantBubble}>
          <Typography variant="caption" sx={styles.assistantLabel}>
            ARELIA AI Assistant
          </Typography>
          {onApply
            ? <AssistantSegments content={line.content} onApply={onApply} onClose={onClose} />
            : <Box sx={styles.messageText}><FormattedText>{line.content}</FormattedText></Box>
          }
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={styles.userRow}>
      <Paper elevation={0} sx={styles.userBubble}>
        <Box sx={styles.messageText}>{line.content}</Box>
      </Paper>
    </Box>
  );
}
